// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__BD-Bd","noInteraction":"EventWrapper_noInteraction__33J_A","pointerPassthrough":"EventWrapper_pointerPassthrough__3_Dyi"};